import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOptionsComponent } from './fi-options.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiOptionsItemComponent } from './fi-options-item.component';
import { FiOptionsIconItemComponent } from './fi-options-icon-item.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatIconModule, FormsModule],
    declarations: [FiOptionsComponent, FiOptionsItemComponent, FiOptionsIconItemComponent],
    exports: [FiOptionsComponent, FiOptionsItemComponent, FiOptionsIconItemComponent],
})
export class FiOptionsModule {}
